import React from 'react';
import HeroSection from '../components/HeroSection';
import CertificationBanner from '../components/CertificationBanner';
import AboutIntro from '../components/AboutIntro';
import WhyRecruitAI from '../components/WhyRecruitAI';
import ClientCarousel from '../components/ClientCarousel';
import BenefitsSection from '../components/BenefitsSection';
import FeaturesSection from '../components/FeaturesSection';
import IndustriesSection from '../components/IndustriesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import RequestDemoSection from '../components/RequestDemoSection';

const Home = () => {
  return (
    <div className="home">
      <HeroSection />
      <CertificationBanner />
      <AboutIntro />
      <WhyRecruitAI />
      <ClientCarousel />
      <BenefitsSection />
      <FeaturesSection />
      <IndustriesSection />
      <TestimonialsSection />
      <RequestDemoSection />
    </div>
  );
};

export default Home; 